import * as React from 'react';
import styled, { css } from 'styled-components';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const PriorityIcon = React.memo(function PriorityIcon(props: TPriorityIconProps): React.ReactElement {
    const { level = 0, ...elementProps } = props;
    return (
        <SIconBase aria-label="Priority" {...elementProps} $level={level}>
            {level === 0 ? (
                <>
                    <rect
                        className="Atlas-NoPriority-Bar"
                        width="2"
                        height="6"
                        rx="0.5"
                        transform="matrix(1 0 0 -1 15.5 18.5)"
                    />
                    <rect
                        className="Atlas-NoPriority-Bar"
                        width="2"
                        height="6"
                        rx="0.5"
                        transform="matrix(1 0 0 -1 10 18.5)"
                    />
                    <rect className="Atlas-NoPriority-Bar" x="4.5" y="12.5" width="2" height="6" rx="0.5" />
                </>
            ) : level === 4 ? (
                <path d="M9.766 4.516a.5.5 0 0 1 .5-.516h1.468a.5.5 0 0 1 .5.516l-.219 8a.5.5 0 0 1-.5.484h-1.03a.5.5 0 0 1-.5-.484l-.219-8ZM10 16.55c0 .248.224.45.5.45h1c.276 0 .5-.201.5-.45V15.2c0-.248-.224-.45-.5-.45h-1c-.276 0-.5.201-.5.45v1.35Z" />
            ) : (
                // TODO: add urgent
                <>
                    <rect className="Atlas-Priority-Bar-1" x="4.5" y="14" width="2" height="3" rx="0.5" />
                    <rect className="Atlas-Priority-Bar-2" x="10" y="10" width="2" height="7" rx="0.5" />
                    <rect className="Atlas-Priority-Bar-3" x="15.5" y="5" width="2" height="12" rx="0.5" />
                </>
            )}
        </SIconBase>
    );
});

export default PriorityIcon;

// #region Styles

const SIconBase = styled(IconBase)<{ $level: TPriorityIconLevel }>`
    .Atlas-NoPriority-Bar {
        opacity: ${(p) => (p.$level === 0 ? 0.3 : 1)};
    }

    .Atlas-Priority-Bar-2 {
        opacity: ${(p) => (p.$level < 2 ? 0.15 : 1)};
    }
    .Atlas-Priority-Bar-3 {
        opacity: ${(p) => (p.$level < 3 ? 0.15 : 1)};
    }
    ${(p) =>
        p.$level === 4
            ? css`
                  color: ${(p) => p.theme.color.red6};
              `
            : ''}
`;

// #endregion

// #region Types

type TPriorityIconLevel = 0 | 1 | 2 | 3 | 4;

export type TPriorityIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>> & {
        level?: TPriorityIconLevel;
    };

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <PriorityIcon />
        : {
              ...IconBaseExample,
              render: PriorityIcon,
              controls: { level: [0, 1, 2, 3, 4], ...IconBaseExample.controls },
          };

// #endregion
